module.exports = __webpack_public_path__ + "img/credit-card-solid-full.dcbd8e0a.png";